._AutoPilotSection_183ys_1,
._Paragraph_183ys_2 {
  margin-bottom: 0.25rem;
  margin-top: 0.25rem;
}
